import { Fragment } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getPaymentReceiptAsync } from "src/api/contract/contract-api";
import { useApiOperation } from "src/api/hooks";
import { CreditCardDetailsProps } from "../types";
import { CancelAmountRow } from "./CancelAmountRow";
import { PriceRow } from "./PriceRow";
import { ViewYmdFormat } from "src/utils/common-util";

// 신용카드 상세 정보 컴포넌트
// 신용카드 결제 정보와 관련된 상세 정보를 표시하는 컴포넌트
export const CreditCardDetails = ({ payment, totalPaymentAmount, receiptBundle, contractCancelList }: CreditCardDetailsProps) => {
  const { t } = useTranslation("contract");
  // 영수증 조회 API 호출
  const { executeAsync: getPaymentReceipt } = useApiOperation(getPaymentReceiptAsync);

  // 거래내역 확인서 URL 조회 함수
  const fetchPaymentReciptUrl = async (payment: any) => {
    const { data } = await getPaymentReceipt({ id: String(payment.paymentId) });
    const url = data.data.receipt_url;

    // React Native WebView 또는 일반 브라우저에서 영수증 열기
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "openInAppBrowser",
          data: {
            event: url,
          },
        }),
      );
    } else {
      window.open(url);
      // window.location.href = url;
    }
  };

  return (
    <>
      {/* 결제 금액 정보 표시 */}
      <PriceRow label={t("detail.productAmount")} value={payment.totalAmount - payment.taxAmount} />
      <PriceRow label={t("detail.vat")} value={payment.taxAmount} />
      <PriceRow label={t("detail.totalPaymentAmount")} value={payment.totalAmount} isTotal />
      {contractCancelList.length > 0 && (
        <CancelAmountRow label="총 취소 금액" totalPaymentAmount={totalPaymentAmount} contractCancelList={contractCancelList} />
      )}

      {/* 카드 정보 표시 */}
      {payment.cardInfo && (
        <>
          <div className="horizontal-divider" />
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.paymentMethod")}</p>
            <p className="base-section-layout-value">{t("detail.cardPayment")}</p>
          </div>
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3"></p>
            <p className="base-section-layout-value text-primary3 font14 font-weight-400 pl80 keep-all">
              {t("detail.cardPaymentReceiptNotice")
                .split("\n")
                .map((line, idx) => (
                  <Fragment key={idx}>
                    {idx > 0 && <br />}
                    {line}
                  </Fragment>
                ))}
            </p>
          </div>
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.cardNumber")}</p>
            <p className="base-section-layout-value">{payment.cardInfo}</p>
          </div>
        </>
      )}

      {/* 결제 취소 또는 결제일시 정보 표시 */}

      {receiptBundle?.lastTrDateTime && (
        <div className="base-section-layout-line">
          <p className="base-section-layout-index text-primary3">{t("detail.paymentDate")}</p>
          <p className="base-section-layout-value">{moment(receiptBundle.lastTrDateTime).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM)}</p>
        </div>
      )}

      {/* 카드 영수증 보기 버튼 */}
      {receiptBundle!.lastTrDateTime! && (
        <button
          className="mt20 base-btn color-white card_payment_receipt"
          onClick={async () => {
            fetchPaymentReciptUrl(payment);
          }}
        >
          {t("detail.viewCardReceipt")}
        </button>
      )}
    </>
  );
};
